import { Outlet } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import AccountSidebar from "../components/AccountSidebar";

export default function AccountLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <SiteHeader />
      <div className="container flex-grow-1 py-4">
        <div className="row h-100">
          <div className="col-12 col-md-4 col-lg-3">
            <AccountSidebar />
          </div>
          <div className="col-12 col-md-8 col-lg-9 d-flex flex-column">
            <main className="flex-grow-1">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
